var _rect, _text, _g, _g2, _text2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalsFigDetectionPasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 430",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 430,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 20,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Every write triggers seven detection passes")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 15,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 84,
    width: 150,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 112,
    fontWeight: 600
  }, "1 Cluster"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "proposes drivers"), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 84,
    width: 150,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 112,
    fontWeight: 600
  }, "2 Convergence"), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "cross-domain"), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 84,
    width: 150,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 112,
    fontWeight: 600
  }, "3 Acceleration"), /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "strength deltas"), /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 84,
    width: 160,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED"
  }), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 112,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "4 Contradiction"), /*#__PURE__*/React.createElement("text", {
    x: 558,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "held as axes"), /*#__PURE__*/React.createElement("rect", {
    x: 714,
    y: 84,
    width: 150,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 112,
    fontWeight: 600
  }, "5 Emergence"), /*#__PURE__*/React.createElement("text", {
    x: 732,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "new domains"), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    y: 84,
    width: 130,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 112,
    fontWeight: 600
  }, "6 Decay"), /*#__PURE__*/React.createElement("text", {
    x: 896,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "gone quiet"), /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 84,
    width: 130,
    height: 64,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#DC2626"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1040,
    y: 112,
    fontWeight: 600,
    fill: "#DC2626"
  }, "7 Gap"), /*#__PURE__*/React.createElement("text", {
    x: 1040,
    y: 134,
    fontSize: 13,
    fill: "#6B7F74"
  }, "STEEP+V"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#9CA89F",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 158 L600 196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594 190 L600 198 L606 190"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 228,
    fontSize: 20,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Findings are triaged, and most stay quiet")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 256,
    width: 352,
    height: 118,
    rx: 10,
    fill: "#EAF6EE",
    stroke: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 288,
    fontWeight: 600,
    fill: "#166534"
  }, "Always surface"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 312,
    fill: "#1A2F2A"
  }, "new convergences, 3+ signal"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 332,
    fill: "#1A2F2A"
  }, "accelerations, unused contradictions,"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 352,
    fill: "#1A2F2A"
  }, "blind spots relevant to the topic"), /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 256,
    width: 352,
    height: 118,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 288,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Surface when relevant"), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 312,
    fill: "#1A2F2A"
  }, "patterns tied to the session's"), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 332,
    fill: "#1A2F2A"
  }, "domain, mode, or question,"), /*#__PURE__*/React.createElement("text", {
    x: 444,
    y: 352,
    fill: "#1A2F2A"
  }, "raised in context or on request"), /*#__PURE__*/React.createElement("rect", {
    x: 800,
    y: 256,
    width: 352,
    height: 118,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#D8D2C2",
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 288,
    fontWeight: 600,
    fill: "#6B7F74"
  }, "Log silently"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 312,
    fill: "#1A2F2A"
  }, "tentative clusters and gaps"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 332,
    fill: "#1A2F2A"
  }, "unrelated to current work,"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 352,
    fill: "#1A2F2A"
  }, "kept queryable, never announced"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalsFigDetectionPasses);
export default __webpack_public_path__ + "static/media/signals-fig-detection-passes.a177549022994189e253d4a77cde21aa.svg";
export { ForwardRef as ReactComponent };